import React, { FC } from 'react'

import { Header as HeaderComponent } from 'components/Header'

interface HeaderProps {}

const Header: FC<HeaderProps> = () => <HeaderComponent />

export default Header
